import { useEffect, useState } from "react";
import api, { STATUS_LABELS } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Warehouse, MapPin, Boxes, ArrowRight } from "lucide-react";

export default function WarehousePage() {
  const [inventory, setInventory] = useState([]);
  const [locations, setLocations] = useState([]);
  const [moveForm, setMoveForm] = useState({ item_id: "", to_location_code: "", note: "" });

  const load = async () => {
    const [inv, loc] = await Promise.all([api.get("/warehouse/inventory"), api.get("/warehouse/locations")]);
    setInventory(inv.data); setLocations(loc.data);
  };
  useEffect(() => { load(); }, []);

  const move = async () => {
    if (!moveForm.item_id || !moveForm.to_location_code) return toast.error("Seleziona prodotto e destinazione");
    try { await api.post("/warehouse/move", moveForm); toast.success("Prodotto spostato"); setMoveForm({ item_id: "", to_location_code: "", note: "" }); load(); }
    catch (e) { toast.error("Errore"); }
  };

  const byLoc = inventory.reduce((acc, it) => { const k = it.current_location_code || "N/D"; (acc[k] = acc[k] || []).push(it); return acc; }, {});

  return (
    <div className="p-4 md:p-8 max-w-6xl mx-auto" data-testid="warehouse-page">
      <div className="mb-6">
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-[#0a0a2e]">Magazzino</h1>
        <p className="text-slate-500">Prodotti in assistenza attualmente presenti in AMA Sicurezza, per ubicazione.</p>
      </div>

      <div className="ama-card p-4 mb-6">
        <div className="text-sm font-semibold text-[#0a0a2e] mb-3">Sposta prodotto</div>
        <div className="grid md:grid-cols-4 gap-2">
          <Select value={moveForm.item_id} onValueChange={(v) => setMoveForm({ ...moveForm, item_id: v })}>
            <SelectTrigger data-testid="warehouse-move-item"><SelectValue placeholder="Prodotto" /></SelectTrigger>
            <SelectContent className="max-h-72">{inventory.map((it) => <SelectItem key={it.id} value={it.id}>{it.item_number} — {it.customer_name}</SelectItem>)}</SelectContent>
          </Select>
          <Select value={moveForm.to_location_code} onValueChange={(v) => setMoveForm({ ...moveForm, to_location_code: v })}>
            <SelectTrigger data-testid="warehouse-move-location"><SelectValue placeholder="Destinazione" /></SelectTrigger>
            <SelectContent>{locations.map((l) => <SelectItem key={l.id} value={l.code}>{l.code} — {l.description}</SelectItem>)}</SelectContent>
          </Select>
          <Input placeholder="Nota (opzionale)" value={moveForm.note} onChange={(e) => setMoveForm({ ...moveForm, note: e.target.value })} />
          <Button data-testid="warehouse-move-save" className="ama-btn-primary" onClick={move}><ArrowRight className="w-4 h-4 mr-1" /> Sposta</Button>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {Object.entries(byLoc).map(([loc, items]) => (
          <div key={loc} className="ama-card p-4" data-testid={`location-${loc}`}>
            <div className="flex items-center gap-2 mb-2"><MapPin className="w-4 h-4 text-[#d63384]" /><div className="font-semibold text-[#0a0a2e]">{loc}</div><span className="text-xs text-slate-500 ml-auto">{items.length} prodotti</span></div>
            <div className="space-y-1">
              {items.map((it) => (
                <div key={it.id} className="flex items-center gap-2 text-sm p-2 rounded-lg hover:bg-slate-50">
                  <Boxes className="w-3 h-3 text-slate-400" />
                  <div className="flex-1 truncate">{it.item_number} — {it.manufacturer_name} · {it.customer_name}</div>
                  <span className="text-xs text-slate-500">{STATUS_LABELS[it.current_status]}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
        {inventory.length === 0 && <div className="ama-card p-8 text-center text-slate-500 md:col-span-2">Magazzino vuoto — nessun prodotto attualmente presente.</div>}
      </div>
    </div>
  );
}
